import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            探索黄油世界
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按分类快速找到你需要的黄油评测与推荐
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 bg-background-100 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 group-hover:bg-primary-200/80 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}